/**
 @ngdoc service
 @name mapClinetmeetingTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapClientmeetingTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;
            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            tileFactory.addFieldToColumn1(tileFactory.field.newField('consultant'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('startDate', 'date'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('purpose'));
            tileFactory.addFieldToColumn4(
                tileFactory.field.newRankedInactiveField('managerPhone', [['ctpsBarring', 'ctpsBarring'], ['unsubscribedFromCalls', 'unsubscribedFromCalls']],
                    'actionLogURI'));
            tileFactory.addFieldToColumn4(tileFactory.field.newLinkField('managerName','managerURI'));

            tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('businessRecordName','businessURI'));
            tileFactory.addFieldToColumn1(tileFactory.field.newAddressField('address'));

            var time = undefined;
            if(rawTileData.time){
                time = rawTileData.time.startTime + ' - ' + rawTileData.time.endTime;
            }
            tileFactory.addFieldToColumn2({label: objectTilesLabels.time.label, value: time});
            tileFactory.addFieldToColumn2(tileFactory.field.newTimeField('duration'));
            tileFactory.addTextField(tileFactory.textField.newTextField('comments'))
            tileFactory.addTextField(tileFactory.textField.newTextField('feedback'))
            tileFactory.addStatus(tileFactory.status.newStatus('clientMeetingStatus',
                [tileFactory.LOOKUP_VALUE.CLIENT_MEETING_ATTENDED],
                [tileFactory.LOOKUP_VALUE.CLIENT_MEETING_CANCELLED]
            ));

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapClientmeetingTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapClientmeetingTileService', mapClientmeetingTileService);
}());